<template>
  <el-row :gutter="16" v-loading="requests == null || returns == null || inventory == null">
    <el-col :xs="24" :sm="12" :style="$mq != 'xs' ? 'border-right: 1px solid #dedede;' : ''">
      <h5>Pending Issue</h5>
      <el-table
        v-if="requests != null && inventory != null"
        :height="windowHeight - 250"
        :data="requests">
        <el-table-column
          label="Item"
          sortable
          min-width="150">
          <template slot-scope="scope">
            <span>{{inventory.find(l => scope.row.item_id == l.o_id).item_name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Amount"
          sortable
          align="center"
          prop="amount"
          min-width="100">
        </el-table-column>
        <el-table-column
          label="Requestor"
          sortable
          prop="requestor.lastName"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <span>{{getFullName(users.find(c => scope.row.user_id == c.o_id))}}</span>
          </template>
        </el-table-column>
        <el-table-column
            :fixed="$mq === 'xs' ? false : 'right'"
            min-width="120"
            align="center">
          <template slot-scope="scope">
            <el-button-group>
              <el-button @click="approveRequest(scope.row)" icon="el-icon-check" type="success" size="small"></el-button>
              <el-button @click="dismissRequest(scope.row)" icon="el-icon-close" type="danger" size="small"></el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table> 
    </el-col>
    <el-col :xs="24" :sm="12">
      <h5>Pending Return</h5>
      <el-table
        v-if="returns != null && inventory != null"
        :height="windowHeight - 250"
        :data="returns">
        <el-table-column
          label="Item"
          sortable
          min-width="150">
          <template slot-scope="scope">
            <span>{{inventory.find(l => scope.row.record.item_id == l.o_id).item_name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Amount"
          sortable
          align="center"
          prop="amount"
          min-width="100">
        </el-table-column>
        <el-table-column
          label="Requestor"
          sortable
          prop="requestor.lastName"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <span>{{getFullName(users.find(c => scope.row.record.user_id == c.o_id))}}</span>
          </template>
        </el-table-column>
        <el-table-column
            :fixed="$mq === 'xs' ? false : 'right'"
            min-width="120"
            align="center">
          <template slot-scope="scope">
            <el-button-group>
              <el-button @click="approveReturn(scope.row)" icon="el-icon-check" type="success" size="small"></el-button>
              <el-button @click="dismissReturn(scope.row)" icon="el-icon-close" type="danger" size="small"></el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table> 
    </el-col>
  </el-row>
</template>

<script>
import {mapFields} from 'vuex-map-fields';

export default {
    props: ['selectedUpdate'],
    mounted() {
        this.pullRequests();
        this.$store.dispatch('pullInventory');
    },
    computed: {
        ...mapFields([
            'user',
            'inventory',
            'users',
            'inventoryTypes'
        ]),

        ainventory() {
            return this.inventory.filter((l) => l.requires_approval);
        }
    },
    data() {
        return {
            returns: null,
            requests: null
        };
    },
    methods: {
        approveReturn(row){
            this.axios.post('/api/v1/inventory/admin/return',
                {'return_id': row.o_id},
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then(() => {
                var temp = this.returns.find((objv) => objv.o_id == row.o_id);
                var index = this.returns.indexOf(temp);
                this.returns.splice(index, 1);
                this.$message({
                    showClose: true,
                    message: 'Inventory return approved.',
                    type: 'success'
                });
            }).catch((err) => {
                console.error(err);
                this.$message({
                    showClose: true,
                    message: err.response.data.errors,
                    type: 'error'
                });
            });
        },
        dismissReturn(row){
            this.axios.delete('/api/v1/inventory/admin/returns/delete/'+row.o_id,
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then(() => {
                var temp = this.returns.find((objv) => objv.o_id == row.o_id);
                var index = this.returns.indexOf(temp);
                this.returns.splice(index, 1);
                this.$message({
                    showClose: true,
                    message: 'Inventory return deleted.',
                    type: 'success'
                });
            }).catch((err) => {
                console.error(err);
                this.$message({
                    showClose: true,
                    message: err.response.data.errors,
                    type: 'error'
                });
            });
        },
        approveRequest(row){
            this.axios.post('/api/v1/inventory/admin/issue',
                {'request_id': row.o_id},
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then(() => {
                var temp = this.requests.find((objv) => objv.o_id == row.o_id);
                var index = this.requests.indexOf(temp);
                this.requests.splice(index, 1);
                this.$message({
                    showClose: true,
                    message: 'Inventory request approved.',
                    type: 'success'
                });
            }).catch((err) => {
                console.error(err);
                this.$message({
                    showClose: true,
                    message: err.response.data.errors,
                    type: 'error'
                });
            });
        },
        dismissRequest(row){
            this.axios.delete('/api/v1/inventory/request/'+row.o_id,
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then(() => {
                var temp = this.requests.find((objv) => objv.o_id == row.o_id);
                var index = this.requests.indexOf(temp);
                this.requests.splice(index, 1);
                this.$message({
                    showClose: true,
                    message: 'Inventory request deleted.',
                    type: 'success'
                });
            }).catch((err) => {
                console.error(err);
                this.$message({
                    showClose: true,
                    message: err.response.data.errors,
                    type: 'error'
                });
            });
        },
        pullRequests(){
            this.axios.get('/api/v1/inventory/admin/requests',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                this.requests = response.data;
            }).catch((err) => {
                console.error(err);
                this.$message({
                    showClose: true,
                    message: err.response.data.errors,
                    type: 'error'
                });
            });
            this.axios.get('/api/v1/inventory/admin/returns',
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                this.returns = response.data;
            }).catch((err) => {
                console.error(err);
                this.$message({
                    showClose: true,
                    message: err.response.data.errors,
                    type: 'error'
                });
            });
        }
    }
}
</script>
